import { gql, TypedDocumentNode } from '@apollo/client';
import { GetGuestReplyIdsQuery, GetGuestReplyIdsQueryVariables } from './__generated__/GuestReplyIdsQuery';

export const GuestReplyIds: TypedDocumentNode<GetGuestReplyIdsQuery, GetGuestReplyIdsQueryVariables> = gql`
    query GetGuestReplyIds($guestId: ID!) {
        guestReplyIds(guestId: $guestId)
    }
`;
